module.exports = __webpack_public_path__ + "static/media/talksCardBackAlt.b48e86c9.svg";